import { render, staticRenderFns } from "./ChatInfo.vue?vue&type=template&id=44e7bc06&scoped=true&lang=pug&"
import script from "./ChatInfo.vue?vue&type=script&lang=js&"
export * from "./ChatInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e7bc06",
  null
  
)

export default component.exports